var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0244 0H1.95773C0.815719 0 0 0.95654 0 1.91306V20.0869C0 21.2029 0.978863 22 1.95773 22H22.0244C23.1664 22 23.9821 21.0435 23.9821 20.0869V1.91306C24.1453 0.79712 23.1664 0 22.0244 0ZM7.99405 13.5507C8.32034 13.8695 8.32034 14.5073 7.99405 14.9855C7.83091 15.1449 7.50462 15.3043 7.34147 15.3043C7.17833 15.3043 6.85204 15.1449 6.6889 14.9855L3.09973 11.4783C2.77345 11.1594 2.77345 10.5218 3.09973 10.0435L6.6889 6.53623C7.01519 6.21739 7.66776 6.21739 8.15719 6.53623C8.64662 6.85507 8.48348 7.49274 8.15719 7.971L5.38375 10.6812L7.99405 13.5507ZM11.7464 17.6956C11.5832 18.1739 11.2569 18.4927 10.7675 18.4927H10.6044C10.1149 18.3333 9.62549 17.8551 9.78863 17.3768L12.3989 4.14493C12.5621 3.66667 13.0515 3.34783 13.5409 3.34783C14.0304 3.50725 14.5198 3.98553 14.3567 4.46379L11.7464 17.6956ZM21.0456 11.4783L17.4564 14.9855C17.2932 15.1449 16.967 15.3043 16.8038 15.3043C16.6407 15.3043 16.3144 15.1449 16.1512 14.9855C15.825 14.6667 15.825 14.029 16.1512 13.5507L18.9247 10.8406L16.1512 8.13043C15.825 7.81159 15.825 7.17392 16.1512 6.69566C16.4775 6.37682 17.1301 6.37682 17.6195 6.69566L21.2087 10.2029C21.3718 10.5218 21.3718 11.1594 21.0456 11.4783Z",
    fill: "#4D8FF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiMini);
export default __webpack_public_path__ + "static/media/api_mini.2fe4a0eb766866c3a8a853a1d760bbc6.svg";
export { ForwardRef as ReactComponent };